<template>
	<popup class="payment_method_popup" title="Update billing details" @close="closePopup">
		<template v-slot:content>
			<div class="content">
            <div class="tab_contents_wrpr ">
                <div class="tab_content form_shipping credit_card_form module__form" >
	                <div class="item_form">
		                <h4 class="title_h4">Your billing details</h4>
		                <div class="line">
			                <div class="row">
				                <div class="col col-6">
					                <input-field label="First name" v-model="user_details.first_name" />
				                </div>
				                <div class="col col-6">
					                <input-field label="Last name" v-model="user_details.last_name" />
				                </div>
			                </div>
		                </div>
		                <div class="line">
			                <!--	                        <input-field label="Company name" />-->
		                </div>
		                <div class="line">
			                <fieldset class="product-name input-field country-fieldset">
				                <legend>Country <span style="color: red;">*</span></legend>
				                <v-select
						                v-model="user_details.country"
						                :options="localCountries"
						                label="text"
						                searchable
						                clearable
						                :reduce="item => item.id"
						                append-to-body
				                />
			                </fieldset>
		                </div>
		                <div class="line">
			                <div class="row">
				                <div class="col col-100">
					                <input-field label="Zip" v-model="user_details.zip" />
				                </div>
				                <div class="col col-200">
					                <input-field label="City" v-model="user_details.city" />
				                </div>
				                <div class="col col-200">
					                <input-field label="State" placeholder="State..." v-model="user_details.state" />
				                </div>
			                </div>
		                </div>
	                </div>
	                <div class="item_form">
		                <h4 class="title_h4">Payment method</h4>
		                <div >

			                <form>
				                <div class="column card" ref="card">

					                <div class="line">
						                <fieldset class="card-input" :class="{'focused':cardFocused, 'error':!!cardError}">
							                <legend>Card number</legend>
							                <div ref="cardNumber"></div>
						                </fieldset>
					                </div>
					                <div class="line">
						                <div class="row" >

							                <div class="col col-6">
								                <fieldset class="product-name card-input" :class="{'focused':expiryFocused, 'error':!!expiryError}">
									                <legend>Expiry</legend>
									                <div ref="expiry"></div>
								                </fieldset>
							                </div>
							                <div class="col col-6">
								                <fieldset class="product-name card-input" :class="{'focused':cvcFocused, 'error':!!cvcError}">
									                <legend>CVC</legend>
									                <div ref="cvc"></div>
								                </fieldset>
							                </div>

						                </div>
					                </div>

				                </div>
			                </form>
		                </div>
	                </div>
                </div>
            </div>
        </div>
		</template>
		<template v-slot:actions>
				<v-button :loading="loading" @click="updateDetails()" label="Update payment method" />
		</template>
	</popup>

</template>

<script>

import Popup from "@/components/base/popup";
import countries from "@/helpers/countries";
import {loadStripe} from '@stripe/stripe-js';
import InputField from "@/components/base/input-field";
import API from '@/api';
import VButton from "@/components/base/v-button";

export default {
	name: "UpdatePaymentMethodPopup",
	components: {
		VButton,
		InputField,
		Popup
  },
	mixins:[API],
	props: [],
  data() {
    return {
      cardError: '',
      cvcError: '',
      expiryError: '',
	    loading: false,
	    cardFocused: false,
	    cvcFocused: false,
	    expiryFocused: false,
	    user_details: {
		    first_name: "",
		    last_name: "",
		    company_name: "",
		    address: '',
		    country: '',
		    zip: '',
		    state: '',
		    city: ''
	    },
	    style: {
		    base: {
			    color: '#32325d',
			    fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
			    fontSmoothing: 'antialiased',
			    fontSize: '16px',
			    '::placeholder': {
				    color: '#aab7c4'
			    }
		    },
		    invalid: {
			    color: '#fa755a',
			    iconColor: '#fa755a'
		    }
	    },
    }
  },
	computed: {
		localCountries(){
			return countries
		},
	},
	methods: {
		onDone() {
			this.closePopup();
			window.location.reload();
			this.$notify({
				group: 'main',
				title: "Your payment details have been updated.",
				type: 'info',
			});
		},
    closePopup(){
      this.$emit('close');
    },
		generateStripeAddress() {
			let address = {};

			if (this.user_details.country) address.country = this.user_details.country;
			if (this.user_details.zip) address.postal_code = this.user_details.country;
			if (this.user_details.address) address.line1 = this.user_details.address;
			if (this.user_details.state) address.state = this.user_details.state;
			if (this.user_details.city) address.city = this.user_details.city;

			return address;
		},
		async updateDetails(paymentMethod=null){
			try {
				this.loading = true;

				let token = paymentMethod ? paymentMethod : "";

				let data = await this.api.billing.updateDetails({
					user_id: parseInt(this.$store.state.userInfo.id),
					gateway_key: 'card', // TODO: paypal
					user_details: this.user_details,
					token: token
				});
				if (!data.success) {
					throw data.error;
				} else if (data.result.needs_approval && !paymentMethod) {
					let confirmResult = await this.confirm(data.result.reference);
					this.onDone();
				} else if (data.success) {
					this.onDone()
				} else {
					this.$notify({
						group: 'main',
						title: "Something went wrong! try again.",
						type: 'error',
					});
				}
			} catch (e) {
				this.$error(e)
			} finally {
				this.loading = false;
			}
		},
		// Auth payment if needs approval, eg. 3DS.
		confirm: async function(ref) {
			let result = await this.stripe.confirmCardSetup(
					ref,
					{
						payment_method: {
							card: this.cardNumber,
							billing_details: {
								name: this.user_details.first_name + ' ' + this.user_details.last_name,
							},
						},
					}
			);
			if (result.error) {
				throw result.error.message
			}

			let data = await this.api.billing.updateDetails({
				user_id: parseInt(this.$store.state.userInfo.id),
				gateway_key: 'card', // TODO: paypal
				user_details: this.user_details,
				token: result.setupIntent.payment_method,
			});
			if (!data.success) {
				throw data.error;
			}
			return result;
		},

		async initStripe() {
			let stripeKey = 'pk_test_nQZ3UAvSOCrRWRHaRkw87Ohh';
			if (window.location.origin==="https://app.funnelish.com")
				stripeKey = 'pk_live_XLay1TWP0g7aBX0xBVnDqH4R';

			this.stripe = await loadStripe(stripeKey);

			// Create an instance of Elements.
			const elements = this.stripe.elements();

			this.cardNumber = elements.create('cardNumber', {
				style: this.style,
				// classes: elementClasses,
			});
			this.cardNumber.mount(this.$refs.cardNumber);
			this.cardNumber.on('focus', (event) => {
				this.cardFocused = true;
			});
			this.cardNumber.on('blur', (event) => {
				this.cardFocused = false;
			});
			this.cardNumber.on('change', (event) => {
				if (event.error) {
					this.cardError = event.error.message;
				} else {
					this.cardError = '';
				}
			});

			const cardExpiry = elements.create('cardExpiry', {
				style: this.style,
				// classes: elementClasses,
			});
			cardExpiry.mount(this.$refs.expiry);
			cardExpiry.on('focus', (event) => {
				this.expiryFocused = true;
			});
			cardExpiry.on('blur', (event) => {
				this.expiryFocused = false;
			});
			cardExpiry.on('change', (event) => {
				if (event.error) {
					this.expiryError = event.error.message;
				} else {
					this.expiryError = '';
				}
			});

			const cardCvc = elements.create('cardCvc', {
				style: this.style,
				// classes: elementClasses,
			});
			cardCvc.mount(this.$refs.cvc);
			cardCvc.on('focus', (event) => {
				this.cvcFocused = true;
			});
			cardCvc.on('blur', (event) => {
				this.cvcFocused = false;
			});
			cardCvc.on('change', (event) => {
				if (event.error) {
					this.cvcError = event.error.message;
				} else {
					this.cvcError = '';
				}
			});
		},

		loadData() {
			let ui = this.$store.state.userInfo;
			let n = ui.member.first_name;
			if (n) {
				let parts = n.split(" ");
				if (parts.length > 1) {
					this.user_details.first_name = parts[0].trim()
					this.user_details.last_name = parts[1].trim()
				} else {
					this.user_details.first_name = n.trim()
					this.user_details.last_name = ""
				}
			}

			this.user_details.country = ui.country;
			this.user_details.zip = ui.zip;
			this.user_details.state = ui.state;
			this.user_details.city = ui.city;
			this.user_details.address = ui.address;
		}
	},
	async mounted() {
		this.plan = this.$route.query.plan ? this.$route.query.plan : 'funnelish-apps';
		this.period = this.$route.query.period ? this.$route.query.period : 'monthly';

		await this.initStripe();

		this.$nextTick(() =>{
			this.loadData()
		});
	},
};
</script>
<style lang="scss">
.payment_method_popup {
	.card-input {
		display: flex;
		padding: 0;
		border: 2px solid #E4E6F1;
		border-radius: 8px;
		height: 41px;
		position: relative;
		transition: 0.15s all ease-in-out;

		&.focused {
			border-color: #4368E0;
			legend {
				color: #4368E0;
			}
		}
		&.error {
			border-color: red;
			legend {
				color: red;
			}
		}
		.StripeElement {
			flex: 1;
			cursor: text;
			padding: 8px 10px;
		}
		legend {
			font-weight: 500;
			font-size: 13px;
			line-height: 150%;
			letter-spacing: 0.02em;
			color: #C5C7D2;
			margin-left: 5px;
			padding: 0 5px;
			display: flex;
			position: absolute;
			top: -10px;
			left: 10px;
			background: white;
		}
	}
}

.billing-page .payment_method_popup .tab_contents_wrpr {
    min-height: 280px;
}
.payment_method_popup .form_shipping .credit_card_form {
    padding: 24px 44px;
    background: #EEF4FF;
    border-radius: 6px;
    max-width: 526px;
    margin: 0 auto;
    margin-bottom: 30px;
}
.payment_method_popup .form_shipping .form_group {
    margin-bottom: 15px;
    width: 100%;
}
.payment_method_popup .input_with_left_icon {
    position: relative;
}
.payment_method_popup .input_with_left_icon .left_icon {
    position: absolute;
    top: 27px;
    left: 9px;
    width: 32px;
    height: 32px;
    min-width: 32px;
    min-height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 2;
    pointer-events: none;
}
.payment_method_popup .form_shipping .form_text_label {
    font-size: inherit;
    color: inherit;
    text-align: left;
}
.payment_method_popup .form_text_label {
    font-weight: 500;
    font-size: 13px;
    line-height: 150%;
    letter-spacing: 0.02em;
    color: #252A32;
    display: block;
    width: 100%;
    margin-bottom: 5px;
}
.payment_method_popup .form_text_label .star {
    font-weight: 500;
    font-size: 13px;
    line-height: 150%;
    letter-spacing: 0.02em;
    color: #FB595B;
}
.payment_method_popup .form_shipping .credit_card_form .control-input {
    padding-left: 45px;
}
.payment_method_popup .form_shipping .credit_card_form .bottom_inputs_wrpr {
    display: flex;
    align-items: flex-start;
}
.payment_method_popup .form_shipping .credit_card_form .bottom_inputs_wrpr .form_group:nth-child(2) {
    max-width: 100px;
    margin-left: 30px;
}
</style>
